import { Modal, Popover } from '@sendible/design-system/src';
import { styled, css } from 'styled-components';

export const ModalComponent = styled(Modal)`
  font-size: 14px; // required to reset fontsize accross sendible and reconnections apps
`;

export const Heading = styled.div`
  align-items: center;
  display: flex;

  > img {
    color: #0085ff;
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }
`;

export const Container = styled.div`
  flex: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  .input {
    flex: 1;

    input {
      margin: 0;
    }
  }

  .right-icon {
    display: none;
  }
`;

export const InputHeader = styled.div`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDark};
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    margin-bottom: 0.25rem;
  `}
`;

export const PopoverComponent = styled(Popover)`
  align-content: center;
  background: #f4f4f4;
  height: 40px;
  padding-left: 0.5rem;
  position: absolute;
  right: 0.5rem;
  top: 0;

  span {
    font-weight: 500;

    &:hover {
      cursor: pointer;
    }
  }
`;

export const PopoverContent = styled.div`
  ${({ theme: { colors, fontSizes } }) => css`
    align-items: flex-start;
    color: ${colors.brandDarkTint30};

    * {
      font-size: ${fontSizes.s12};
      letter-spacing: 0.03em;
      line-height: 1.33em;
    }

    p {
      color: ${colors.brandDarkTint30};
      margin-bottom: 0.75rem;
    }

    a {
      color: ${colors.brandPrimary};
      font-weight: 500;
    }

    ol {
      margin: 0 0 0.75rem 1rem;

      li {
        color: ${colors.brandDarkTint30};
        margin-bottom: 0.5rem;

        &::marker {
          color: ${colors.brandDark};
          font-weight: 500;
        }

        span {
          color: ${colors.brandDark};
          display: block;
          font-weight: 500;
        }
      }
    }

    hr {
      margin: 0.75rem 0 0.75rem 0;
    }
  `}
`;

export const PasswordHelper = styled.div`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDarkTint30};
    font-size: 0.75rem;
    margin: 0.25rem 0 1rem 0;

    a {
      color: ${colors.brandPrimary} !important;
      font-weight: 500;
    }
  `}
`;

export const ReconnectName = styled.div`
  font-size: 1.25rem;
  padding: 0.5em 0 2.188rem 0;
`;

export const Footer = styled.div`
  ${({ theme: { colors, fontSizes } }) => css`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-top: 1rem;

    p {
      color: ${colors.brandDark};
      font-size: ${fontSizes.s12};
    }
  `}
`;
